<template>
              <v-avatar 
                size="36px"
              >
                <img
                  :src="userImage"
                  alt="Avatar"
                  v-bind:class="[this.myEdit ? 'saved' : 'not-saved']"                  
                >
              </v-avatar>
</template>
 

<script>
  import {mapState} from 'vuex'
  export default {
    data: () => ({
      slider: 50,
      tile: false
    }),

    computed: mapState(['userImage','isLoggedIn','myEdit']),
    ...{
      avatarSize () {
        return this.slider
      }
    }
  }
</script>

<style scoped>
    .cntrl{
        background-color:red !important;
        justify-content: end !important;
    }
    .saved{
      border: 1px solid green;
    }
    .not-saved{
      border: 3px solid red;
    }
</style>
